import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateVehicle($companyId: ID!, $id: ID!, $attributes: VehicleAttributes!) {
    updateVehicle(companyId: $companyId, id: $id, attributes: $attributes) {
      vehicle {
        id
        ...UpdatedVehicle
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedVehicle on Vehicle {
    id
    name
    registration
    warehouse {
      id
      name
    }
    rateCents
    mileageCents
    model
    manufacturer
    cabSize
    width
    height
    length
    payload
    notes
  }
`
